module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_distance.79018225.svg";